export default __webpack_public_path__ + "static/media/logo_eduhub.ff423884.png";